// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/shotlist/v1/vision_shot.proto (package protos.vision.shotlist.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/shotlist/v1/vision_shot.proto.
 */
export const file_vision_shotlist_v1_vision_shot: GenFile = /*@__PURE__*/
  fileDesc("CiR2aXNpb24vc2hvdGxpc3QvdjEvdmlzaW9uX3Nob3QucHJvdG8SGXByb3Rvcy52aXNpb24uc2hvdGxpc3QudjEi6wMKClZpc2lvblNob3QSDwoHc2hvdF9pZBgBIAEoCRISCgpwcm9qZWN0X2lkGAIgASgJEhAKCGltYWdlX2lkGAMgASgJEhIKCnNvcnRfb3JkZXIYBCABKAUSEwoLc2hvdF9udW1iZXIYBSABKAkSDQoFc2NlbmUYBiABKAkSEAoIbG9jYXRpb24YByABKAkSEwoLZGVzY3JpcHRpb24YCCABKAkSEAoIY2FzdF9pZHMYCSADKAkSEgoKZnJhbWVfc2l6ZRgKIAEoCRINCgVhbmdsZRgLIAEoCRIXCg9jYW1lcmFfbW92ZW1lbnQYDCABKAkSEQoJZXF1aXBtZW50GA0gAygJEg0KBXByb3BzGA4gAygJEhYKDmRpcmVjdG9yX25vdGVzGA8gASgJEhAKCGRwX25vdGVzGBAgASgJEhEKCXZmeF9ub3RlcxgRIAEoCRIRCglzZnhfbm90ZXMYEiABKAkSEAoIZGlhbG9ndWUYEyABKAkSFQoNc2hvb3RpbmdfdGltZRgUIAEoCRIuCgpjcmVhdGVkX2F0GBUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GBYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcGIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.shotlist.v1.VisionShot
 */
export type VisionShot = Message<"protos.vision.shotlist.v1.VisionShot"> & {
  /**
   * @generated from field: string shot_id = 1;
   */
  shotId: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: string image_id = 3;
   */
  imageId: string;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;

  /**
   * @generated from field: string shot_number = 5;
   */
  shotNumber: string;

  /**
   * @generated from field: string scene = 6;
   */
  scene: string;

  /**
   * @generated from field: string location = 7;
   */
  location: string;

  /**
   * @generated from field: string description = 8;
   */
  description: string;

  /**
   * @generated from field: repeated string cast_ids = 9;
   */
  castIds: string[];

  /**
   * @generated from field: string frame_size = 10;
   */
  frameSize: string;

  /**
   * @generated from field: string angle = 11;
   */
  angle: string;

  /**
   * @generated from field: string camera_movement = 12;
   */
  cameraMovement: string;

  /**
   * @generated from field: repeated string equipment = 13;
   */
  equipment: string[];

  /**
   * @generated from field: repeated string props = 14;
   */
  props: string[];

  /**
   * @generated from field: string director_notes = 15;
   */
  directorNotes: string;

  /**
   * @generated from field: string dp_notes = 16;
   */
  dpNotes: string;

  /**
   * @generated from field: string vfx_notes = 17;
   */
  vfxNotes: string;

  /**
   * @generated from field: string sfx_notes = 18;
   */
  sfxNotes: string;

  /**
   * @generated from field: string dialogue = 19;
   */
  dialogue: string;

  /**
   * @generated from field: string shooting_time = 20;
   */
  shootingTime: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 21;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 22;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.shotlist.v1.VisionShot.
 * Use `create(VisionShotSchema)` to create a new message.
 */
export const VisionShotSchema: GenMessage<VisionShot> = /*@__PURE__*/
  messageDesc(file_vision_shotlist_v1_vision_shot, 0);

